module.exports = __webpack_public_path__ + "static/media/hourglass_circle_goldf188314b6f4ccd204e199163cdb245f2.webp";